module.exports = __webpack_public_path__ + "static/banner2-b75496593ea240564bda994ed7fe0214.png";